import { html, View } from 'rune-ts';
import klass from './Icon.module.scss';
import { cx } from '../util';

/**************************************************************
 *   # ICON
 *   ## 아이콘 파일 생성시,
 *      - theme 속성에 맞게 색상이 변하도록 currentColor 를 이용.
 *        - 이때 theme 에 맞게 변하는 path 만 변경함
 *        - 절대로 theme 를 이용할 일이 없다면 해시코드 사용하여 막기
 *      - size 속성에 맞게 크기가 변하도록 width, height 100%로 설정
 *   ## 아이콘 이름
 *      - snake_case
 *      - fill / unfill 된 아이콘이 있을 가능성이 있다면 _fill 표기
 *      - icon X (star_icon -> star)
 * *************************************************************/

const outlink = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  style="cursor: pointer;"
>
  <path
    d="M8.67633 3.57129H4.99986C4.21088 3.57129 3.57129 4.21088 3.57129 4.99986V14.9999C3.57129 15.7888 4.21088 16.4284 4.99986 16.4284H14.9999C15.7888 16.4284 16.4284 15.7888 16.4284 14.9999V11.5125"
    stroke="currentColor"
    stroke-width="1.07143"
    stroke-linecap="round"
  />
  <path
    d="M12.1426 3.57129H16.4283V7.857"
    stroke="currentColor"
    stroke-width="1.07143"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M16.4286 3.57129L10 9.99986"
    stroke="currentColor"
    stroke-width="1.07143"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>`;

const slide = html` <svg
  xmlns="http://www.w3.org/2000/svg"
  width="28"
  height="28"
  viewBox="0 0 28 28"
  fill="none"
>
  <path
    d="M6.35351 23.6465C6.98114 25.0343 8.3778 26 10 26H22C24.2091 26 26 24.2091 26 22V10C26 8.3778 25.0343 6.98114 23.6465 6.35351C23.8736 6.85565 24 7.41306 24 8V20C24 22.2091 22.2091 24 20 24H8C7.41306 24 6.85565 23.8736 6.35351 23.6465Z"
    fill="currentColor"
  />
  <path
    d="M2 6C2 3.79086 3.79086 2 6 2H18C20.2091 2 22 3.79086 22 6V18C22 20.2091 20.2091 22 18 22H6C3.79086 22 2 20.2091 2 18V6Z"
    fill="currentColor"
  />
</svg>`;

const search = html`
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 28 28" fill="none">
    <path
      d="M25.2259 25L18.2259 18C19.7887 16.3811 20.75 14.1778 20.75 11.75C20.75 6.77944 16.7206 2.75 11.75 2.75C6.77944 2.75 2.75 6.77944 2.75 11.75C2.75 16.7206 6.77944 20.75 11.75 20.75C12.5269 20.75 13.2809 20.6516 14 20.4665"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
`;

const home = html`
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
    <path
      d="M3 12L12.7335 4.03621C13.4703 3.43343 14.5297 3.43343 15.2665 4.03621L25 12"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6 13.25V22.25C6 23.3546 6.89543 24.25 8 24.25H14V18.25M22 13.25V22.25C22 23.3546 21.1046 24.25 20 24.25H17.5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
`;

const star_fill = html`
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 16 16" fill="none">
    <path
      d="M7.08736 2.44094C7.37464 1.55679 8.62547 1.55679 8.91275 2.44094L9.72372 4.93685C9.85219 5.33226 10.2207 5.59997 10.6364 5.59997H13.2608C14.1904 5.59997 14.577 6.78958 13.8248 7.33602L11.7017 8.87857C11.3654 9.12295 11.2246 9.55611 11.3531 9.95151L12.1641 12.4474C12.4513 13.3316 11.4394 14.0668 10.6873 13.5204L8.56413 11.9778C8.22778 11.7334 7.77233 11.7334 7.43598 11.9778L5.31283 13.5204C4.56073 14.0668 3.54878 13.3316 3.83606 12.4474L4.64703 9.95151C4.7755 9.55611 4.63476 9.12295 4.29841 8.87857L2.17526 7.33602C1.42316 6.78958 1.80969 5.59997 2.73934 5.59997H5.36369C5.77944 5.59997 6.14791 5.33226 6.27639 4.93685L7.08736 2.44094Z"
      fill="currentColor"
    />
  </svg>
`;

const information = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="100%"
  height="100%"
  viewBox="0 0 20 20"
  fill="none"
  style="cursor: pointer;"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.0011 1.49976C5.30669 1.49976 1.50111 5.30533 1.50111 9.99976C1.50111 14.6942 5.30669 18.4998 10.0011 18.4998C14.6955 18.4998 18.5011 14.6942 18.5011 9.99976C18.5011 5.30533 14.6955 1.49976 10.0011 1.49976Z"
    fill="#D8D8D8"
  />
  <path
    d="M9.19863 11.7097C9.21597 10.196 9.66085 9.73378 10.4235 9.26001C10.9088 8.96535 11.2786 8.5378 11.2786 7.93115C11.2786 7.20894 10.7239 6.7525 10.0306 6.7525C9.40663 6.7525 8.79997 7.13383 8.74798 7.98892H7.5C7.54622 6.51562 8.65553 5.71252 10.0306 5.71252C11.5328 5.71252 12.5381 6.61384 12.5381 7.93115C12.5381 8.86135 12.0932 9.47956 11.3595 9.93022C10.6662 10.352 10.3946 10.768 10.3773 11.7097V11.7791H9.19863V11.7097ZM9.01375 13.4546C9.00797 13.0039 9.38352 12.6342 9.83418 12.6342C10.2791 12.6342 10.6488 13.0039 10.6546 13.4546C10.6488 13.9053 10.2791 14.2692 9.83418 14.275C9.38352 14.2692 9.00797 13.9053 9.01375 13.4546Z"
    fill="white"
  />
</svg>`;

const arrow_left = html` <svg
  xmlns="http://www.w3.org/2000/svg"
  width="100%"
  height="100%"
  viewBox="0 0 24 24"
  fill="none"
>
  <path
    d="M16 3L7 12L16 21"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>`;

const arrow_right = html` <svg
  xmlns="http://www.w3.org/2000/svg"
  width="100%"
  height="100%"
  viewBox="0 0 24 24"
  fill="none"
>
  <path
    d="M8 3L17 12L8 21"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>`;

const arrow_button_left = html` <svg
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
>
  <path
    d="M13.332 2.5L5.83203 10L13.332 17.5"
    stroke="black"
    stroke-width="1.6875"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>`;

const add = html` <svg
  xmlns="http://www.w3.org/2000/svg"
  width="100%"
  height="100%"
  viewBox="0 0 22 22"
  fill="none"
>
  <path
    d="M1 11H11M11 11H21M11 11V21M11 11V1"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    fill="currentColor"
  />
</svg>`;

const expand = html`
  <svg width="24" height="25" viewBox="0 0 24 25" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 12.5L12 12.5M12 12.5L22 12.5M12 12.5L12 22.5M12 12.5L12 2.5"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
`;
const collapse = html`
  <svg width="24" height="25" viewBox="0 0 24 25" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 12.5L12 12.5L22 12.5" stroke="black" stroke-width="2" stroke-linecap="round" />
  </svg>
`;

const share = html` <svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
>
  <path
    d="M18.4277 14.7859C17.2358 14.7859 16.1856 15.3691 15.5206 16.2566L9.04985 13.0211C9.1459 12.6951 9.21345 12.357 9.21345 12.0001C9.21345 11.6433 9.1459 11.3052 9.04985 10.9791L15.5206 7.74372C16.1856 8.63116 17.2358 9.21442 18.4277 9.21442C20.4367 9.21442 22.0706 7.5805 22.0706 5.57157C22.0706 3.56264 20.4367 1.92871 18.4277 1.92871C16.4188 1.92871 14.7849 3.56264 14.7849 5.57157C14.7849 5.92841 14.8524 6.26648 14.9485 6.59256L8.47768 9.82798C7.81269 8.94055 6.7625 8.35728 5.57059 8.35728C3.56166 8.35728 1.92773 9.99121 1.92773 12.0001C1.92773 14.0091 3.56166 15.643 5.57059 15.643C6.7625 15.643 7.81269 15.0597 8.47768 14.1723L14.9485 17.4077C14.8524 17.7338 14.7849 18.0719 14.7849 18.4287C14.7849 20.4376 16.4188 22.0716 18.4277 22.0716C20.4367 22.0716 22.0706 20.4376 22.0706 18.4287C22.0706 16.4198 20.4367 14.7859 18.4277 14.7859ZM16.0706 5.57157C16.0706 4.27163 17.1278 3.21442 18.4277 3.21442C19.7277 3.21442 20.7849 4.27163 20.7849 5.57157C20.7849 6.87151 19.7277 7.92871 18.4277 7.92871C17.74 7.92871 17.1261 7.62779 16.6948 7.15663C16.4049 6.83991 16.1977 6.44796 16.1148 6.0094C16.088 5.86715 16.0706 5.7215 16.0706 5.57157ZM5.57059 14.3573C4.27065 14.3573 3.21345 13.3001 3.21345 12.0001C3.21345 10.7002 4.27065 9.643 5.57059 9.643C6.25829 9.643 6.87227 9.94391 7.3035 10.4151C7.59344 10.7318 7.80061 11.1237 7.88348 11.5623C7.91037 11.7046 7.92774 11.8502 7.92774 12.0001C7.92774 12.1501 7.91038 12.2957 7.88348 12.438C7.80061 12.8765 7.59344 13.2685 7.3035 13.5852C6.87227 14.0564 6.25829 14.3573 5.57059 14.3573ZM18.4277 20.7859C17.1278 20.7859 16.0706 19.7287 16.0706 18.4287C16.0706 18.2788 16.088 18.1331 16.1149 17.9909C16.1977 17.5523 16.4049 17.1604 16.6948 16.8436C17.1261 16.3725 17.74 16.0716 18.4277 16.0716C19.7277 16.0716 20.7849 17.1288 20.7849 18.4287C20.7849 19.7287 19.7277 20.7859 18.4277 20.7859Z"
    fill="currentColor"
  />
</svg>`;

const empty_check = html`
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.0965 25H4.92256C3.87039 25 3.00952 24.0571 3.00952 22.9048V5.09524C3.00952 3.94286 3.87039 3 4.92256 3H23.0965C24.1487 3 25.0095 3.94286 25.0095 5.09524V22.9048C25.0095 24.0571 24.1487 25 23.0965 25Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
`;

const active_check = html`
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.0965 25H4.92256C3.87039 25 3.00952 24.0571 3.00952 22.9048V5.09524C3.00952 3.94286 3.87039 3 4.92256 3H23.0965C24.1487 3 25.0095 3.94286 25.0095 5.09524V22.9048C25.0095 24.0571 24.1487 25 23.0965 25Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20 11L12.6667 17.6667L8 13.6667"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
`;

const heart = html`
  <svg width="100%" height="100%" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14 23.5L5.03774 14.6469C4.80627 14.4509 4.5922 14.2376 4.39479 14.008C3.93221 13.4713 3.5674 12.8491 3.32666 12.1676C3.11481 11.5691 3 10.9269 3 10.2573C3 7.08292 5.58181 4.5 8.75694 4.5C11.085 4.5 13.0946 5.89072 13.9998 7.88439C14.9054 5.89072 16.9146 4.5 19.2438 4.5C22.4174 4.5 25 7.08292 25 10.2573C25 10.9421 24.8796 11.5995 24.6596 12.2091C24.3696 13.0102 23.9071 13.7284 23.3167 14.3198L17.25 20.39"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
`;

const heart_fill = html`
  <svg width="100%" height="100%" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.2438 4.5C22.4174 4.5 25 7.08292 25 10.2573C25 10.9421 24.8796 11.5995 24.6596 12.2091C24.3696 13.0102 23.9071 13.7284 23.3167 14.3198L14.74 23.6915C14.3427 24.1255 13.6584 24.1245 13.2625 23.6892L5.03774 14.6469C4.80627 14.4509 4.5922 14.2376 4.39479 14.008C3.93221 13.4713 3.5674 12.8491 3.32666 12.1676C3.11481 11.5691 3 10.9269 3 10.2573C3 7.08292 5.58181 4.5 8.75694 4.5C11.085 4.5 13.0946 5.89072 13.9998 7.88439C14.9054 5.89072 16.9146 4.5 19.2438 4.5Z"
      fill="#FF6B00"
      stroke="#FF6B00"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
`;

const closed = html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M3.00195 3L21.002 21M3.00195 21L21.002 3"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
`;
const save = html` <svg
  xmlns="http://www.w3.org/2000/svg"
  width="18"
  height="18"
  viewBox="0 0 18 18"
  fill="none"
>
  <path
    d="M3.2264 16.8569H14.774C15.9246 16.8569 16.8574 15.9241 16.8574 14.7735V5.57695C16.8574 5.02442 16.6379 4.49451 16.2472 4.10381L13.8961 1.75277C13.5054 1.36207 12.9755 1.14258 12.423 1.14258H3.2264C2.07581 1.14258 1.14307 2.07532 1.14307 3.22591V14.7735C1.14307 15.9241 2.07581 16.8569 3.2264 16.8569Z"
    stroke="currentColor"
    stroke-width="1.29"
    stroke-linecap="round"
  />
  <path
    d="M11.1429 5.42773H4"
    stroke="currentColor"
    stroke-width="1.29"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <rect
    x="4"
    y="11.1426"
    width="10"
    height="5.71429"
    stroke="currentColor"
    stroke-width="1.29"
    stroke-linejoin="round"
  />
</svg>`;

const filter = html` <svg
  xmlns="http://www.w3.org/2000/svg"
  width="12"
  height="13"
  viewBox="0 0 12 13"
  fill="none"
>
  <path d="M3 6.50001H9M2 4H10M4 9H8" stroke="#858585" stroke-linecap="round" />
</svg>`;

const arrow_up = html` <svg
  xmlns="http://www.w3.org/2000/svg"
  width="100%"
  height="100%"
  viewBox="0 0 24 24"
  fill="none"
>
  <path
    d="M21 16L12 7L3 16"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>`;

const arrow_down = html` <svg
  xmlns="http://www.w3.org/2000/svg"
  width="100%"
  height="100%"
  viewBox="0 0 24 24"
  fill="none"
>
  <path
    d="M21 8L12 17L3 8"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>`;

const arrow_narrow_down = html` <svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
>
  <path d="M12 3.42847L12 20.5713" stroke="currentColor" stroke-width="1.28571" stroke-linecap="round" />
  <path
    d="M16.5 16.0715L12 20.5716L7.49995 16.0715"
    stroke="currentColor"
    stroke-width="1.28571"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>`;

const arrow_thick_down = html` <svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
>
  <path
    d="M21 8L12 17L3 8"
    stroke="#D8D8D8"
    stroke-width="4"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>`;

const information2 = html` <svg
  xmlns="http://www.w3.org/2000/svg"
  width="100%"
  height="100%"
  viewBox="0 0 18 18"
  fill="none"
>
  <path
    d="M8.43584 7.24356H9.56436V12.9705H8.43584V7.24356ZM8.99482 6.35762C8.86826 6.35762 8.75049 6.32773 8.6415 6.26797C8.53604 6.2082 8.4499 6.12734 8.38311 6.02539C8.31982 5.92344 8.28818 5.8127 8.28818 5.69316C8.28818 5.57363 8.31982 5.46289 8.38311 5.36094C8.4499 5.25898 8.53779 5.17813 8.64678 5.11836C8.75928 5.05859 8.87881 5.02871 9.00537 5.02871C9.13193 5.02871 9.24971 5.05859 9.35869 5.11836C9.46768 5.17813 9.55381 5.25898 9.61709 5.36094C9.68037 5.46289 9.71201 5.57363 9.71201 5.69316C9.71201 5.81621 9.67861 5.92871 9.61182 6.03066C9.54854 6.13262 9.4624 6.21348 9.35342 6.27324C9.24443 6.32949 9.1249 6.35762 8.99482 6.35762Z"
    fill="currentColor"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9.0001 15.7496C12.728 15.7496 15.7501 12.7275 15.7501 8.99961C15.7501 5.27169 12.728 2.24961 9.0001 2.24961C5.27218 2.24961 2.2501 5.27169 2.2501 8.99961C2.2501 12.7275 5.27218 15.7496 9.0001 15.7496ZM9.0001 16.6496C13.2251 16.6496 16.6501 13.2246 16.6501 8.99961C16.6501 4.77463 13.2251 1.34961 9.0001 1.34961C4.77512 1.34961 1.3501 4.77463 1.3501 8.99961C1.3501 13.2246 4.77512 16.6496 9.0001 16.6496Z"
    fill="currentColor"
  />
</svg>`;

const link = html` <svg
  xmlns="http://www.w3.org/2000/svg"
  width="14"
  height="14"
  viewBox="0 0 14 14"
  fill="none"
>
  <path
    d="M5.93317 7.81089C6.47641 8.57705 7.3083 9.05653 8.21293 9.12488C9.11756 9.19323 10.0057 8.84371 10.6469 8.16703L12.5224 6.18847C13.707 4.89456 13.6901 2.83782 12.4843 1.56582C11.2786 0.293825 9.329 0.275952 8.10249 1.52565L7.02721 2.65344"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M8.06668 6.189C7.52344 5.42284 6.69155 4.94336 5.78692 4.87501C4.88229 4.80666 3.99412 5.15618 3.35293 5.83286L1.47743 7.81142C0.292831 9.10533 0.309773 11.1621 1.51551 12.4341C2.72125 13.7061 4.67084 13.7239 5.89735 12.4742L6.96639 11.3465"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>`;

const arrow_triangle = html` <svg
  xmlns="http://www.w3.org/2000/svg"
  width="100%"
  height="100%"
  viewBox="0 0 12 12"
  fill="none"
>
  <path d="M6 9L2 3H10L6 9Z" fill="currentColor" />
</svg>`;

const download = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="21"
  viewBox="0 0 24 21"
  fill="none"
>
  <path d="M1 19.3333H12H23" stroke="black" stroke-width="1.5" stroke-linecap="round" />
  <path d="M12 1L12 7.41667L12 13.8333" stroke="black" stroke-width="1.5" stroke-linecap="round" />
  <path d="M17.5 8.33331L14.75 11.0833L12 13.8333" stroke="black" stroke-width="1.5" stroke-linecap="round" />
  <path d="M6.5 8.33331L9.25 11.0833L12 13.8333" stroke="black" stroke-width="1.5" stroke-linecap="round" />
</svg>`;

const help = html` <svg
  xmlns="http://www.w3.org/2000/svg"
  width="18"
  height="18"
  viewBox="0 0 18 18"
  fill="none"
>
  <path
    d="M2.0625 10.3125V12.1042C2.0625 13.3928 3.10717 14.4375 4.39583 14.4375H13.6042C14.8928 14.4375 15.9375 13.3928 15.9375 12.1042V10.3125"
    stroke="black"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <path
    d="M13.5 12L11.25 10.125L10.9688 9.89062M4.5 12L6.75 10.125L7.03125 9.89062"
    stroke="black"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <path
    d="M13.6042 3.5625H4.39583C3.10717 3.5625 2.0625 4.60717 2.0625 5.89583V6L7.69367 9.80484C8.48292 10.3381 9.51708 10.3381 10.3063 9.80484L15.9375 6V5.89583C15.9375 4.60717 14.8928 3.5625 13.6042 3.5625Z"
    stroke="black"
    stroke-width="1.5"
    stroke-linejoin="round"
  />
  <path
    d="M15.9375 7.6875V5.89583C15.9375 4.60717 14.8928 3.5625 13.6042 3.5625L4.39583 3.5625C3.10717 3.5625 2.0625 4.60717 2.0625 5.89583V7.6875"
    stroke="black"
    stroke-width="1.5"
    stroke-linecap="round"
  />
</svg>`;

const biz = html`
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.19481 12.0227C9.60902 12.0227 9.94481 11.6869 9.94481 11.2727C9.94481 10.8585 9.60902 10.5227 9.19481 10.5227V12.0227ZM6 4.75H21.2208V3.25H6V4.75ZM4.75 9.27273V6H3.25V9.27273H4.75ZM9.19481 10.5227H6V12.0227H9.19481V10.5227ZM22.4708 6V8.15584H23.9708V6H22.4708ZM3.25 9.27273C3.25 10.7915 4.48121 12.0227 6 12.0227V10.5227C5.30964 10.5227 4.75 9.96308 4.75 9.27273H3.25ZM21.2208 4.75C21.9111 4.75 22.4708 5.30964 22.4708 6H23.9708C23.9708 4.48122 22.7396 3.25 21.2208 3.25V4.75ZM6 3.25C4.48122 3.25 3.25 4.48122 3.25 6H4.75C4.75 5.30965 5.30965 4.75 6 4.75V3.25Z"
      fill="black"
    />
    <path
      d="M4.75 14.9091C4.75 14.4949 4.41421 14.1591 4 14.1591C3.58579 14.1591 3.25 14.4949 3.25 14.9091H4.75ZM22.4708 6V21.2208H23.9708V6H22.4708ZM21.2208 22.4708H6V23.9708H21.2208V22.4708ZM4.75 21.2208V14.9091H3.25V21.2208H4.75ZM13.3506 4.75H21.2208V3.25H13.3506V4.75ZM6 22.4708C5.30965 22.4708 4.75 21.9111 4.75 21.2208H3.25C3.25 22.7396 4.48122 23.9708 6 23.9708V22.4708ZM22.4708 21.2208C22.4708 21.9111 21.9111 22.4708 21.2208 22.4708V23.9708C22.7396 23.9708 23.9708 22.7396 23.9708 21.2208H22.4708ZM23.9708 6C23.9708 4.48122 22.7396 3.25 21.2208 3.25V4.75C21.9111 4.75 22.4708 5.30965 22.4708 6H23.9708Z"
      fill="black"
    />
    <path
      d="M15.4285 19.0649C15.4285 18.6346 15.7773 18.2857 16.2077 18.2857C16.638 18.2857 16.9869 18.6346 16.9869 19.0649V24H15.4285V19.0649Z"
      fill="black"
    />
    <g clip-path="url(#clip0_7113_352164)">
      <path
        d="M16.9872 7.63634C16.9872 7.20599 16.6383 6.85712 16.2079 6.85712C15.7776 6.85712 15.4287 7.20599 15.4287 7.63634V15.4285C15.4287 15.8589 15.7776 16.2078 16.2079 16.2078C16.6383 16.2078 16.9872 15.8589 16.9872 15.4285V7.63634Z"
        fill="black"
      />
      <path
        d="M13.2204 8.90532C12.8477 8.69014 12.3711 8.81784 12.156 9.19053C11.9408 9.56323 12.0685 10.0398 12.4412 10.255L19.1894 14.1511C19.5621 14.3662 20.0387 14.2386 20.2539 13.8659C20.469 13.4932 20.3413 13.0166 19.9687 12.8014L13.2204 8.90532Z"
        fill="black"
      />
      <path
        d="M12.441 12.8014C12.0683 13.0166 11.9406 13.4931 12.1558 13.8658C12.371 14.2385 12.8475 14.3662 13.2202 14.151L19.9685 10.2549C20.3412 10.0398 20.4689 9.5632 20.2537 9.1905C20.0385 8.8178 19.562 8.69011 19.1893 8.90529L12.441 12.8014Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_7113_352164">
        <rect width="8.31169" height="9.35065" fill="white" transform="translate(12.052 6.85712)" />
      </clipPath>
    </defs>
  </svg>
`;

const mypage_change = html`
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.5416 14.2916H5.54159C4.25292 14.2916 3.20825 15.3363 3.20825 16.625V21.2916"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M7.38881 10.2083C6.44432 9.49881 5.83325 8.36944 5.83325 7.0972C5.83325 4.94943 7.57437 3.20831 9.72214 3.20831C11.8699 3.20831 13.611 4.94943 13.611 7.0972C13.611 8.36933 13.0002 9.4988 12.0559 10.2083"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M18.359 21.0243L24.38 10.5957C25.0243 9.47966 24.6419 8.05262 23.5259 7.40828L23.0207 7.11662C21.9047 6.47229 20.4777 6.85466 19.8333 7.97068L12.3481 20.9356"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M12.3481 20.9355L13.1631 24.774L16.8948 23.5605"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M16.4893 20.0023L18.3438 21.0234" stroke="black" stroke-width="1.5" stroke-linecap="round" />
  </svg>
`;

const mypage_ordered = html`
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M30.1369 25.6627V7.09896C30.1369 5.81029 29.0923 4.76562 27.8036 4.76562H9.41146C8.12279 4.76562 7.07812 5.81029 7.07812 7.09896V32.4911C7.07812 33.7798 8.12279 34.8244 9.41146 34.8244H10.3722"
      stroke="black"
      stroke-width="2.12"
    />
    <path
      d="M13.6652 25.7656V32.4911C13.6652 33.7798 12.6205 34.8244 11.3319 34.8244H10.3711"
      stroke="black"
      stroke-width="2.12"
      stroke-linecap="round"
    />
    <path
      d="M34.2546 25.7656V32.4911C34.2546 33.7798 33.2099 34.8244 31.9213 34.8244H30.9605H21.0781"
      stroke="black"
      stroke-width="2.12"
      stroke-linecap="round"
    />
    <path d="M13.6719 25.6484H34.0487" stroke="black" stroke-width="2.12" stroke-linecap="round" />
    <path
      d="M13.4922 11.5312H23.6889M13.4922 16.4724H18.7698"
      stroke="black"
      stroke-width="2.12"
      stroke-linecap="round"
    />
  </svg>
`;

const contents = html` <svg
  xmlns="http://www.w3.org/2000/svg"
  width="40"
  height="40"
  viewBox="0 0 40 40"
  fill="none"
>
  <path
    d="M18.1265 33.7364H11.8802C8.06364 33.7364 5.92227 29.3414 8.27442 26.3358L16.2188 16.1847V7.02734H22.3237V16.1847L23.8499 17.9017"
    stroke="black"
    stroke-width="2.12"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M12 6.93359C12 6.38131 12.4477 5.93359 13 5.93359H26C26.5523 5.93359 27 6.38131 27 6.93359C27 7.48588 26.5523 7.93359 26 7.93359H13C12.4477 7.93359 12 7.48588 12 6.93359Z"
    fill="black"
  />
  <path
    d="M34.5319 25.9279C34.5319 30.4501 26.9007 34.1161 26.9007 34.1161C26.9007 34.1161 19.2695 30.4501 19.2695 25.9279C19.2695 21.6886 24.2992 20.0004 26.5002 24.8653C26.6431 25.181 27.1583 25.181 27.3012 24.8653C29.5022 20.0007 34.5319 21.6887 34.5319 25.9279Z"
    stroke="black"
    stroke-width="2.12"
    stroke-linejoin="round"
  />
</svg>`;

const star_on = html`
  <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.04894 0.927049C5.3483 0.00573826 6.6517 0.00573993 6.95106 0.927051L7.5716 2.83688C7.70547 3.2489 8.08943 3.52786 8.52265 3.52786H10.5308C11.4995 3.52786 11.9023 4.76748 11.1186 5.33688L9.49395 6.51722C9.14347 6.77187 8.99681 7.22323 9.13068 7.63525L9.75122 9.54508C10.0506 10.4664 8.9961 11.2325 8.21238 10.6631L6.58778 9.48278C6.2373 9.22813 5.7627 9.22814 5.41221 9.48278L3.78761 10.6631C3.0039 11.2325 1.94942 10.4664 2.24878 9.54508L2.86932 7.63526C3.00319 7.22323 2.85653 6.77186 2.50604 6.51722L0.881445 5.33688C0.0977311 4.76748 0.500508 3.52786 1.46923 3.52786H3.47735C3.91057 3.52786 4.29453 3.2489 4.4284 2.83688L5.04894 0.927049Z"
      fill="black"
    />
  </svg>
`;

const star_off = html`
  <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.04894 0.927049C5.3483 0.0057382 6.6517 0.00573985 6.95106 0.92705L7.5716 2.83688C7.70547 3.2489 8.08943 3.52786 8.52265 3.52786H10.5308C11.4995 3.52786 11.9023 4.76748 11.1186 5.33688L9.49395 6.51722C9.14347 6.77187 8.99681 7.22323 9.13068 7.63526L9.75122 9.54508C10.0506 10.4664 8.9961 11.2325 8.21238 10.6631L6.58778 9.48278C6.2373 9.22813 5.7627 9.22813 5.41221 9.48278L3.78761 10.6631C3.0039 11.2325 1.94942 10.4664 2.24877 9.54508L2.86932 7.63526C3.00319 7.22323 2.85653 6.77186 2.50604 6.51722L0.881445 5.33688C0.0977311 4.76748 0.500508 3.52786 1.46923 3.52786H3.47735C3.91057 3.52786 4.29453 3.2489 4.4284 2.83688L5.04894 0.927049Z"
      fill="#D8D8D8"
    />
  </svg>
`;

const logo = html` <svg
  xmlns="http://www.w3.org/2000/svg"
  width="170"
  height="20"
  viewBox="0 0 170 20"
  fill="none"
>
  <path
    d="M46.05 15.5261L39.44 -0.00390625H35.2L30.25 11.6061L28.59 15.5161L28.34 16.0861L26.68 19.9961H30.92L32.58 16.0861L32.83 15.5161H41.81L42.06 16.0861L43.72 19.9961H47.96L46.3 16.0861L46.05 15.5161V15.5261ZM34.49 11.6261L37.31 4.98609L40.14 11.6261H34.48H34.49Z"
    fill="black"
  />
  <path d="M134.36 -0.00390625H130.05V19.9961H144.58V16.0861H134.36V-0.00390625Z" fill="black" />
  <path
    d="M10.01 8.45609L4.32 -0.00390625H0V19.9961H4.32V7.62609L9.63 15.5161L10.01 16.0861L10.39 15.5161L15.7 7.62609V19.9961H20.01V-0.00390625H15.7L10.01 8.45609Z"
    fill="black"
  />
  <path
    d="M69.28 16.0661L68.89 15.4961L67.85 13.9861L67.38 13.2961C68.79 12.6161 69.93 11.4861 70.62 10.0861C71.08 9.15609 71.34 8.10609 71.34 6.99609C71.34 5.88609 71.08 4.83609 70.62 3.90609C69.87 2.38609 68.59 1.18609 67.02 0.536094C66.19 0.196094 65.29 0.00609375 64.34 0.00609375H54.65V20.0061H58.97V14.0061H62.93L67.02 19.9961H71.95L71.34 19.1161L69.28 16.0861H69.29L69.28 16.0661ZM58.96 3.86609H63.93C65.64 3.86609 67.02 5.25609 67.02 6.95609C67.02 8.65609 65.63 10.0461 63.93 10.0461H58.96V3.86609Z"
    fill="black"
  />
  <path
    d="M93.02 0.526094C92.19 0.186094 91.29 -0.00390625 90.33 -0.00390625H80.64V19.9961H84.96V13.9961H90.33C91.28 13.9961 92.19 13.8061 93.02 13.4661C94.59 12.8161 95.87 11.6061 96.62 10.0961C97.08 9.16609 97.34 8.11609 97.34 7.00609C97.34 5.89609 97.08 4.84609 96.62 3.91609C95.87 2.39609 94.59 1.19609 93.02 0.546094H93.03L93.02 0.526094ZM89.93 10.0761H84.96V3.89609H89.93C91.63 3.89609 93.02 5.28609 93.02 6.98609C93.02 8.68609 91.63 10.0761 89.93 10.0761Z"
    fill="black"
  />
  <path
    d="M118.41 0.526094C117.59 0.186094 116.68 -0.00390625 115.73 -0.00390625H106.04V19.9961H110.36V13.9961H115.74C116.69 13.9961 117.6 13.8061 118.42 13.4661C119.99 12.8161 121.26 11.6061 122.02 10.0961C122.48 9.16609 122.74 8.11609 122.74 7.00609C122.74 5.89609 122.48 4.84609 122.02 3.91609C121.27 2.39609 120 1.19609 118.42 0.546094L118.41 0.526094ZM115.32 10.0761H110.35V3.89609H115.32C117.03 3.89609 118.41 5.28609 118.41 6.98609C118.41 8.68609 117.02 10.0761 115.32 10.0761Z"
    fill="black"
  />
  <path
    d="M155.48 -0.00390625V7.83609H148.95V12.1461H155.48V19.9961H170V16.0761H159.79V12.1461H166.1V7.83609H159.79V3.91609H170V-0.00390625H155.48Z"
    fill="black"
  />
</svg>`;

const require_dot = html` <div
  style="width: 100%; height: 100%; justify-content: flex-start; align-items: flex-start; gap: 10px; display: inline-flex"
>
  <div class=${klass.require}></div>
</div>`;

const mail = html`
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.25 13.75V16.9167C3.25 18.2053 4.29467 19.25 5.58333 19.25H19.4167C20.7053 19.25 21.75 18.2053 21.75 16.9167V13.75"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M18.5 16L15.5 13.5L15.125 13.1875M6.5 16L9.5 13.5L9.875 13.1875"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M19.4167 4.75H5.58333C4.29467 4.75 3.25 5.79467 3.25 7.08333V8L11.1937 13.3673C11.9829 13.9006 13.0171 13.9006 13.8063 13.3673L21.75 8V7.08333C21.75 5.79467 20.7053 4.75 19.4167 4.75Z"
      stroke="black"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M21.75 10.25V7.08333C21.75 5.79467 20.7053 4.75 19.4167 4.75L5.58333 4.75C4.29467 4.75 3.25 5.79467 3.25 7.08333V10.25"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
`;

const link_to = html`
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.4117 4.28577H6.28564C5.18108 4.28577 4.28564 5.1812 4.28564 6.28577V17.7143C4.28564 18.8189 5.18108 19.7143 6.28565 19.7143H17.7142C18.8188 19.7143 19.7142 18.8189 19.7142 17.7143V13.8152"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M14.5713 4.28577H19.7141V9.42862"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.7143 4.28577L12 12.0001"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
`;

const arrow_2_down = html`<svg
  width="18"
  height="18"
  viewBox="0 0 18 18"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M9 2.57129L9 15.4284"
    stroke="currentColor"
    stroke-width="1.125"
    stroke-linecap="round"
    stroke-linejoin="bevel"
  />
  <path
    d="M5.625 12.0537L9 15.4287L12.375 12.0537"
    stroke="currentColor"
    stroke-width="1.125"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg> `;

const copyright = html`<svg
  width="100%"
  height="100%"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M2.84375 6.34375C2.85156 4.5625 4.28906 3.125 6.0625 3.125C7.61719 3.125 8.92188 4.21875 9.10938 5.67188H7.67188C7.53125 4.99219 6.84375 4.50781 6.0625 4.5C5.05469 4.50781 4.22656 5.32031 4.23438 6.34375C4.22656 7.35938 5.05469 8.17969 6.0625 8.1875C6.84375 8.17969 7.44531 7.69531 7.57812 7.01562H9.03125C8.82812 8.46094 7.61719 9.5625 6.0625 9.5625C4.28906 9.5625 2.85156 8.125 2.84375 6.34375ZM0.1875 6.34375C0.195312 3.11719 2.8125 0.507812 6.01562 0.515625C9.25781 0.507812 11.8438 3.11719 11.8594 6.34375C11.8594 9.5625 9.25781 12.1797 6.01562 12.1719C2.8125 12.1797 0.171875 9.5625 0.1875 6.34375ZM1.65625 6.34375C1.64844 8.73438 3.61719 10.7031 6.01562 10.7031C8.42969 10.7031 10.3906 8.75 10.375 6.34375C10.3672 3.92969 8.42188 1.98438 6.01562 1.98438C3.625 1.98438 1.67188 3.9375 1.65625 6.34375Z"
    fill="#858585"
  />
</svg>`;

const arrow_down_fill = html` <svg
  xmlns="http://www.w3.org/2000/svg"
  width="12"
  height="12"
  viewBox="0 0 12 12"
  fill="none"
>
  <path d="M6 9L2 3H10L6 9Z" fill="currentColor" />
</svg>`;

const icons_fill = {
  star_fill,
  heart_fill,
  arrow_down_fill,
};
const icons_default = {
  outlink,
  arrow_up,
  arrow_down,
  arrow_left,
  arrow_right,
  arrow_narrow_down,
  arrow_thick_down,
  arrow_button_left,
  arrow_2_down,
  slide,
  information,
  search,
  home,
  add,
  share,
  empty_check,
  active_check,
  heart,
  closed,
  save,
  filter,
  link,
  arrow_triangle,
  information2,
  download,
  help,
  biz,
  mypage_change,
  mypage_ordered,
  contents,
  star_on,
  star_off,
  logo,
  require_dot,
  expand,
  collapse,
  mail,
  copyright,
  link_to,
};

const icons = {
  ...icons_fill,
  ...icons_default,
};

type IconTheme =
  | 'none'
  | 'gray-100'
  | 'gray-200'
  | 'gray-300'
  | 'gray-400'
  | 'gray-500'
  | 'gray-600'
  | 'gray-700'
  | 'gray-800'
  | 'gray-900'
  | 'black'
  | 'white'
  | 'primary';

export interface IconData {
  name: keyof typeof icons;
  class?: string;
  theme?: IconTheme;
  size?: number | 'auto';
  mo_size?: number | 'auto';
}

export class Icon extends View<IconData> {
  static icons = icons;

  constructor(data: IconData) {
    super({
      ...data,
      theme: data.theme || 'none',
      size: data.size || 'auto',
      mo_size: data.mo_size || data.size || 'auto',
    });
  }

  override template() {
    return html`<span
      class="${cx(this.data.class, klass.icon)}"
      data-icon="${this.data.name}"
      data-theme="${this.data.theme}"
      data-size="${this.data.size}"
      data-mo-size="${this.data.mo_size}"
    >
      ${Icon.icons[this.data.name]}
    </span> `;
  }
}
